/**
 * 会员下拉框
 * 2019-08-02 chenxiaojian
 */
import React from 'react';
import { Select } from 'antd';


import http from '../../../axios/http';

class MemberSelect extends React.Component {

    state = {
        list: []
    }

    componentDidMount() {
        this.loadMeterInfo(this.props);
        if (this.props.onRef) {
            this.props.onRef(this)
        }
    }

    loadMeterInfo = (param) => {
        http.post({
            url: '/member/findMember',
            data: {
                tenant: param.tenant,
                agent: param.agent,
                mall: param.mall,
                orgCode: param.orgCode
            },
            success: (res) => {
                this.setState({ list: res });
            }
        });
    }

    onSelect = (key) => {
        let list = this.state.list;
        if (list != null && list.length > 0) {
            for (let i = 0; i < list.length; i++) {
                if (list[i]["code"] === key) {
                    this.props.onSelect(list[i]);
                }
            }
        }
    }

    render() {
        let onSelect = this.props.onSelect ? this.onSelect : null;
        return <Select {...this.props} onSelect={onSelect}
            showSearch={true}
            allowClear={this.props.allowClear === true}
            optionFilterProp="children"
        >
            {this.state.list.map(d =>
                <Select.Option
                    key={d["code"]}>
                    {d["name"] + "[" + d["code"] + "]"}
                </Select.Option>
            )}
        </Select>
    };
}

export default MemberSelect;